export default __webpack_public_path__ + "static/media/Mainmob.a610e23e.png";